<template>
    <nav v-if="menu" id="navbar" :class="{ 'navbar-mobile': isActive }" class="navbar order-last order-lg-0">
      <ul>
        <MenuItemComponent 
          v-for="menuitem in menu" 
          :key="menuitem.id_module" 
          :item="menuitem"
          :submenu=false
          :isactive="isActive"
          @linkClick="navToogleLink"
        />
      </ul>
      <i @click.prevent="navToogle" class="bi bi-list mobile-nav-toggle rounded-0 p-1"></i>
    </nav>
  </template>
  
  <script>
  import { useStore } from 'vuex'
  import { computed, ref } from 'vue'
  import MenuItemComponent from './MenuItemComponent.vue'
  
  export default {
    name: 'MenuComponent',
    components: { MenuItemComponent },
    setup() {
      const store = useStore()
      const menu = computed(() => store.state.menu)
      const isActive = ref(false)
  
      const navToogle = () => {
        isActive.value = !isActive.value
      }
      
      const navToogleLink = () => {
        if(isActive.value){
          isActive.value = false
        }
      }
     
  
      return { menu, navToogle, isActive, navToogleLink }
    }
  }
  </script>
  